import { takeEvery, select, put } from 'redux-saga/effects'
// @ts-ignore
import { store } from 'store'
import i18next from 'i18next'

import { getImageToDelete, getUsagePlacesForDeletedImage } from 'store/entities/gallery/selectors'
// @ts-ignore
import { showError } from 'store/entities/toastr/utils'
import { setImageToDelete, deleteImageFromGallery } from 'store/entities/gallery/actions'
// @ts-ignore
import { modal } from 'store/entities/modal/actions'
import GalleryDeleteImageModal from 'app/domains/common/Modals/ConfirmOrCancel'

export default function* deleteImageSaga() {
  yield takeEvery(setImageToDelete, handleDeleteImageRequest)
}

export function* handleDeleteImageRequest() {
  try {
    const image = yield select(getImageToDelete)
    const usagePlaces = yield select(getUsagePlacesForDeletedImage)
    const activitiesUrl = 'https://assets.stg.prohabits.com/activities'
    const result = image.includes(activitiesUrl)
    let text
    if (usagePlaces !== '') {
      text =
        i18next.t('admin:This image used here') +
        '\n' +
        usagePlaces
          .replace(/______/g, '<br/><b>')
          .replace(/___/g, '</b>')
          .replace(/__/g, '<br/>')
    }
    yield put(
      modal.show(GalleryDeleteImageModal, {
        title: i18next.t('admin:Are you sure you want to delete this Image?'),
        dangerouslyText: usagePlaces !== '' ? { __html: text } : null,
        handleSubmit: () => {
          modal.hide()
          store.dispatch(deleteImageFromGallery(image))
        },
        confirmBtn: i18next.t('common:Delete'),
        cancelBtn: i18next.t('common:Cancel'),
        size: 'sm',
        showButtons: result || usagePlaces === '',
      })
    )
  } catch (error) {
    showError()
  }
}
